import React, { useState } from 'react'
import { currencyFormat } from '../../../Product/common/components'
// import ReactApexChart from 'react-apexcharts'

const PriceTracker = (props) => {
    const cardData = [
        {
            name: 'Lowest Price',
            amount: '285.00',
            date: 'Apr 15, 2024',
        },
        {
            name: 'Highest Price',
            amount: '285.00',
            date: 'Apr 15, 2024',
        },
        {
            name: 'Current Avg',
            amount: '285.00',
            date: 'Apr 15, 2024',
        },
    ]

    const styles = [{ color: '#16a249' }, { color: '#e12114' }, { color: '#000000' }]

    const options = {
        chart: {
            type: 'area',
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        stroke: {
            curve: 'smooth',
            width: 3,
            colors: ['#16a249'], // green line
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 0.3,
                opacityFrom: 0.4,
                opacityTo: 0.05,
                stops: [0, 90, 100],
            },
        },
        dataLabels: {
            enabled: false,
        },
        markers: {
            size: 0, // no dots
        },
        grid: {
            strokeDashArray: 4,
            borderColor: '#e5e7eb',
        },
        xaxis: {
            categories: [
                'Jan 1',
                'Jan 15',
                'Feb 1',
                'Feb 15',
                'Mar 1',
                'Mar 15',
                'Apr 1',
                'Apr 15',
                'May 1',
                'May 15',
            ],
            labels: {
                style: {
                    colors: '#6b7280',
                },
            },
        },
        yaxis: {
            min: 0,
            max: 320,
            tickAmount: 4,
            labels: {
                formatter: (val) => `$${val}`,
                style: {
                    colors: '#6b7280',
                },
            },
            title: {
                text: 'Price ($)',
                style: {
                    color: '#6b7280',
                },
            },
        },
        legend: {
            position: 'bottom',
            markers: {
                width: 6,
                height: 6,
                radius: 12,
            },
        },
        tooltip: {
            y: {
                formatter: (val) => `$${val}`,
            },
        },
    }

    const series = [
        {
            name: 'Average Price',
            data: [320, 310, 318, 305, 315, 300, 308, 295, 305, 312],
        },
    ]

    return (
        <>
            <div className="pricingContainer">
                <h3 className="h3">Historical Pricing</h3>
                {/* <ReactApexChart options={options} series={series} type="area" height={350} /> */}
                <h3 className="text-center fw-bold w-100 my-5">Chart Not Available</h3>
                <div className="minianalyticsContainer">
                    {cardData.map((data, index) => (
                        <div className="pricingSmallCard" id={`index${index}`} key={index}>
                            <p>{data.name}</p>
                            <p className="amount" style={styles[index % styles.length]}>
                                {currencyFormat(parseFloat(data.amount).toFixed(2))}
                            </p>
                            <p className="date">{data.date}</p>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default PriceTracker
